import { render, staticRenderFns } from "./MenuOption.vue?vue&type=template&id=54ad5e00&scoped=true&"
import script from "./MenuOption.vue?vue&type=script&lang=js&"
export * from "./MenuOption.vue?vue&type=script&lang=js&"
import style0 from "./MenuOption.vue?vue&type=style&index=0&id=54ad5e00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad5e00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/dan/github/webdev-personal/dan-anan-wedding/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VCheckbox,VFlex,VLayout,VTextField})
